import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = ({ isOpen, onClose, message, reason }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/pricing');
  };

  if (!isOpen) return null;

  // Determine the message based on reason
  const getTitle = () => {
    if (reason === 'FREE_ACCOUNT_LIMIT' || message?.includes('profile')) {
      return "You've Reached The Profile Limit For Your Plan!";
    }
    return "You've Reached The Story Limit For Your Plan!";
  };

  const getSubtitle = () => {
    if (reason === 'FREE_ACCOUNT_LIMIT' || message?.includes('profile')) {
      return "Upgrade To Create Unlimited Profiles.";
    }
    return "Upgrade To Create Unlimited Stories.";
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-purple-200/30 backdrop-blur-sm p-4">
      <div className="relative bg-white rounded-lg shadow-2xl max-w-md w-full">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Content */}
        <div className="px-8 py-10 text-center">
          {/* Logo */}
          <div className="mb-6">
            <span className="text-3xl font-black tracking-tight leading-none select-none">
              <span className="text-[#ff405c]">my</span>
              <span className="text-[#5c3fd8]">STORYme</span>
            </span>
          </div>

          {/* Title */}
          <h2 className="text-xl font-semibold text-[#5c3fd8] mb-2">
            {getTitle()}
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-[#5c3fd8] mb-8">
            {getSubtitle()}
          </p>

          {/* Upgrade Button */}
          <button
            onClick={handleUpgrade}
            className="w-full bg-[#ff405c] hover:bg-[#e63950] text-white font-semibold py-3 px-6 rounded-lg transition-colors shadow-md"
          >
            Upgrade now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
